import { render, staticRenderFns } from "./Motd.vue?vue&type=template&id=6734627c&scoped=true"
import script from "./Motd.vue?vue&type=script&lang=ts"
export * from "./Motd.vue?vue&type=script&lang=ts"
import style0 from "./Motd.vue?vue&type=style&index=0&id=6734627c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6734627c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6734627c')) {
      api.createRecord('6734627c', component.options)
    } else {
      api.reload('6734627c', component.options)
    }
    module.hot.accept("./Motd.vue?vue&type=template&id=6734627c&scoped=true", function () {
      api.rerender('6734627c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Motd.vue"
export default component.exports